import React from 'react';
import { Check, Shield, BookOpen, Smartphone, Star, ArrowRight, Lock } from 'lucide-react';
import { SocialProofPopup } from '../components/SocialProofPopup';
export function SalesPage() {
  const scrollToPurchase = () => {
    const element = document.getElementById('compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-slate-50 font-sans text-gray-800" data-id="element-9">
      <SocialProofPopup data-id="element-10" />

      {/* 1. HOOK PODEROSO - Hero Section */}
      <header className="bg-white pt-8 pb-16 px-4 md:px-8 lg:px-16 overflow-hidden" data-id="element-11">
        <div className="max-w-6xl mx-auto" data-id="element-12">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-13">
            <div className="space-y-6 text-center md:text-left" data-id="element-14">
              <div className="inline-block bg-blue-50 text-blue-800 px-4 py-2 rounded-full text-sm font-semibold mb-2" data-id="element-15">
                Para personas mayores de 40 años
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 leading-tight" data-id="element-16">
                Usar el celular no debería dar miedo
              </h1>
              <p className="text-xl md:text-2xl text-slate-600 font-medium" data-id="element-17">
                No sos vos. Está mal explicado.
              </p>
              <p className="text-lg text-slate-500 max-w-lg mx-auto md:mx-0" data-id="element-18">
                Un manual paso a paso, sin palabras difíciles, para que aprendas
                a tu ritmo y no dependas de nadie.
              </p>

              <div className="pt-4" data-id="element-19">
                <button onClick={scrollToPurchase} className="w-full md:w-auto bg-blue-600 hover:bg-blue-700 text-white text-xl font-bold py-4 px-8 rounded-xl shadow-lg transform transition hover:scale-105 flex items-center justify-center gap-2" data-id="element-20">
                  Empezar a aprender hoy <ArrowRight className="w-6 h-6" data-id="element-21" />
                </button>
                <p className="text-sm text-slate-400 mt-3 flex items-center justify-center md:justify-start gap-1" data-id="element-22">
                  <Lock className="w-3 h-3" data-id="element-23" /> Compra segura · Descarga
                  inmediata
                </p>
              </div>
            </div>

            <div className="relative mx-auto md:mr-0 max-w-md md:max-w-full cursor-pointer transform transition hover:scale-105 duration-300" onClick={scrollToPurchase} data-id="element-24">
              <div className="absolute -inset-4 bg-blue-100 rounded-full opacity-50 blur-3xl -z-10" data-id="element-25"></div>
              <img src="https://cdn.magicpatterns.com/uploads/qFYHVew2Fp41i7vsjHK3Do/ChatGPT_Image_11_ene_2026,_16_33_43.png" alt="Manual para aprender a usar el celular sin ayuda" className="w-full h-auto rounded-2xl shadow-2xl border-4 border-white" data-id="element-26" />
              <div className="absolute bottom-4 right-4 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-lg shadow-lg text-sm font-bold text-blue-900" data-id="element-27">
                Click para ver más
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* 2. HABLAR AL AVATAR - Direct Language Section */}
      <section className="py-16 px-4 bg-slate-50" data-id="element-28">
        <div className="max-w-4xl mx-auto text-center" data-id="element-29">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-8" data-id="element-30">
            Sé exactamente cómo te sentís
          </h2>
          <p className="text-xl text-slate-700 mb-6 leading-relaxed" data-id="element-31">
            Sos una persona capaz, que resolvió miles de problemas en tu vida.
            Criaste hijos, trabajaste, manejaste tu casa, tomaste decisiones
            importantes.
          </p>
          <p className="text-xl text-slate-700 mb-6 leading-relaxed" data-id="element-32">
            Pero cuando agarrás el celular, sentís que todo cambió. Como si de
            repente no entendieras nada.
          </p>
          <p className="text-xl text-slate-700 font-medium" data-id="element-33">
            Y no es tu culpa.{' '}
            <span className="text-blue-600" data-id="element-34">
              Nadie te explicó con paciencia.
            </span>
          </p>
        </div>
      </section>

      {/* 3. TOCAR DOLOR PRINCIPAL - Pain Points */}
      <section className="py-16 px-4 bg-white" data-id="element-35">
        <div className="max-w-4xl mx-auto" data-id="element-36">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-slate-900 mb-12" data-id="element-37">
            ¿Te pasa esto todos los días?
          </h2>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-38">
            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-100" data-id="element-39">
              <div className="bg-red-100 w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-40">
                <span className="text-2xl" data-id="element-41">😟</span>
              </div>
              <h3 className="text-xl font-bold text-slate-800 mb-3" data-id="element-42">
                "Tengo miedo de tocar algo mal"
              </h3>
              <p className="text-slate-600" data-id="element-43">
                El temor a borrar algo importante o desconfigurar el teléfono te
                paraliza. Preferís no usarlo antes que equivocarte.
              </p>
            </div>

            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-100" data-id="element-44">
              <div className="bg-orange-100 w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-45">
                <span className="text-2xl" data-id="element-46">😓</span>
              </div>
              <h3 className="text-xl font-bold text-slate-800 mb-3" data-id="element-47">
                "No quiero molestar a mis hijos"
              </h3>
              <p className="text-slate-600" data-id="element-48">
                Te da vergüenza preguntar siempre lo mismo. Sentís que no tienen
                paciencia y que sos una carga.
              </p>
            </div>

            <div className="bg-slate-50 p-8 rounded-2xl border border-slate-100" data-id="element-49">
              <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-50">
                <span className="text-2xl" data-id="element-51">😕</span>
              </div>
              <h3 className="text-xl font-bold text-slate-800 mb-3" data-id="element-52">
                "Me siento cada vez más atrás"
              </h3>
              <p className="text-slate-600" data-id="element-53">
                Ves que todos manejan el celular con facilidad y vos seguís sin
                entender. Te sentís excluido del mundo digital.
              </p>
            </div>
          </div>

          <div className="mt-12 bg-red-50 border-l-4 border-red-500 p-8 rounded-r-xl" data-id="element-54">
            <p className="text-xl text-slate-800 font-medium mb-4" data-id="element-55">
              Y lo peor de todo es el desgaste emocional:
            </p>
            <ul className="space-y-3 text-lg text-slate-700" data-id="element-56">
              <li className="flex items-start gap-3" data-id="element-57">
                <span className="text-red-500 font-bold" data-id="element-58">•</span>
                <span data-id="element-59">
                  La ansiedad cada vez que necesitás hacer algo en el celular
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-60">
                <span className="text-red-500 font-bold" data-id="element-61">•</span>
                <span data-id="element-62">La frustración de no poder ser independiente</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-63">
                <span className="text-red-500 font-bold" data-id="element-64">•</span>
                <span data-id="element-65">
                  El miedo a caer en una estafa porque no sabés identificarlas
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-66">
                <span className="text-red-500 font-bold" data-id="element-67">•</span>
                <span data-id="element-68">
                  La resignación de usar solo lo mínimo y perderte todo lo demás
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* 4. CONTEXTO DEL MOMENTO - Urgency */}
      <section className="py-16 px-4 bg-blue-900 text-white" data-id="element-69">
        <div className="max-w-4xl mx-auto text-center" data-id="element-70">
          <div className="inline-block bg-yellow-400 text-blue-900 font-bold px-6 py-2 rounded-full text-sm uppercase tracking-wide mb-6" data-id="element-71">
            Oportunidad por tiempo limitado
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-72">
            Este es el momento de cambiar esa situación
          </h2>
          <p className="text-xl text-blue-100 mb-8 leading-relaxed" data-id="element-73">
            Cada día que pasa sin aprender, es un día más de dependencia, de
            ansiedad, de quedarte afuera.
            <span className="block mt-4 font-bold text-white" data-id="element-74">
              Pero hoy podés decidir que eso se termina.
            </span>
          </p>
          <p className="text-lg text-blue-200" data-id="element-75">
            Miles de personas mayores de 40 ya recuperaron su confianza. Ahora
            es tu turno.
          </p>
        </div>
      </section>

      {/* 5. PRESENTACIÓN DE LA SOLUCIÓN */}
      <section className="py-16 px-4 bg-white" data-id="element-76">
        <div className="max-w-5xl mx-auto" data-id="element-77">
          <div className="text-center mb-16" data-id="element-78">
            <span className="text-blue-600 font-bold tracking-wider uppercase text-sm" data-id="element-79">
              La solución que estabas buscando
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mt-2 mb-6" data-id="element-80">
              Manual "Celular Sin Ayuda"
            </h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto mb-8" data-id="element-81">
              Un manual digital paso a paso, con lenguaje simple y fotos claras,
              diseñado específicamente para personas mayores de 40 años que
              quieren usar su celular sin miedo y sin depender de nadie.
            </p>
            <div className="inline-block bg-green-50 border-2 border-green-500 rounded-xl p-6" data-id="element-82">
              <p className="text-2xl font-bold text-green-800 mb-2" data-id="element-83">
                ¿Por qué este manual SÍ funciona?
              </p>
              <p className="text-lg text-green-700" data-id="element-84">
                Porque está hecho por alguien que entiende tu frustración, no
                por un técnico que habla en otro idioma.
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-85">
            <div className="space-y-6" data-id="element-86">
              <div className="flex gap-4 items-start" data-id="element-87">
                <div className="bg-green-100 p-2 rounded-full mt-1" data-id="element-88">
                  <Check className="w-6 h-6 text-green-600" data-id="element-89" />
                </div>
                <div data-id="element-90">
                  <h3 className="text-xl font-bold text-slate-900" data-id="element-91">
                    Lenguaje 100% cotidiano
                  </h3>
                  <p className="text-slate-600" data-id="element-92">
                    Sin términos en inglés ni palabras técnicas. Hablamos como
                    vos. Cada paso explicado con palabras que usás todos los
                    días.
                  </p>
                </div>
              </div>

              <div className="flex gap-4 items-start" data-id="element-93">
                <div className="bg-green-100 p-2 rounded-full mt-1" data-id="element-94">
                  <Check className="w-6 h-6 text-green-600" data-id="element-95" />
                </div>
                <div data-id="element-96">
                  <h3 className="text-xl font-bold text-slate-900" data-id="element-97">
                    Paso a paso con imágenes
                  </h3>
                  <p className="text-slate-600" data-id="element-98">
                    Cada instrucción tiene su foto para que sepas exactamente
                    dónde tocar. No hay lugar para confusiones.
                  </p>
                </div>
              </div>

              <div className="flex gap-4 items-start" data-id="element-99">
                <div className="bg-green-100 p-2 rounded-full mt-1" data-id="element-100">
                  <Check className="w-6 h-6 text-green-600" data-id="element-101" />
                </div>
                <div data-id="element-102">
                  <h3 className="text-xl font-bold text-slate-900" data-id="element-103">
                    Para Android y iPhone
                  </h3>
                  <p className="text-slate-600" data-id="element-104">
                    No importa qué marca de celular tengas, el manual te sirve
                    igual. Todo está explicado para ambos sistemas.
                  </p>
                </div>
              </div>

              <div className="flex gap-4 items-start" data-id="element-105">
                <div className="bg-green-100 p-2 rounded-full mt-1" data-id="element-106">
                  <Check className="w-6 h-6 text-green-600" data-id="element-107" />
                </div>
                <div data-id="element-108">
                  <h3 className="text-xl font-bold text-slate-900" data-id="element-109">
                    A tu ritmo, sin presión
                  </h3>
                  <p className="text-slate-600" data-id="element-110">
                    Podés leerlo cuando quieras, volver atrás las veces que
                    necesites. Nadie te apura ni te juzga.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-xl transform rotate-1 hover:rotate-0 transition duration-300" data-id="element-111">
              <div className="aspect-[3/4] bg-slate-100 rounded-lg overflow-hidden relative" data-id="element-112">
                <img src="https://cdn.magicpatterns.com/uploads/qFYHVew2Fp41i7vsjHK3Do/ChatGPT_Image_11_ene_2026,_16_33_43.png" alt="Vista previa del manual" className="w-full h-full object-cover" data-id="element-113" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-16 px-4 bg-blue-900 text-white overflow-hidden relative" data-id="element-114">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10" data-id="element-115">
          <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-blue-400 blur-3xl" data-id="element-116"></div>
          <div className="absolute top-1/2 right-0 w-64 h-64 rounded-full bg-purple-400 blur-3xl" data-id="element-117"></div>
        </div>

        <div className="max-w-6xl mx-auto relative z-10" data-id="element-118">
          <div className="text-center mb-12" data-id="element-119">
            <span className="bg-yellow-400 text-blue-900 font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wide mb-4 inline-block" data-id="element-120">
              Solo por hoy
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-121">
              🎁 REGALOS EXCLUSIVOS
            </h2>
            <p className="text-xl text-blue-100" data-id="element-122">
              Comprando el manual hoy, te llevás estos 3 bonos totalmente GRATIS
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-123">
            {/* Bonus 1 */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/20 transition cursor-pointer group" onClick={scrollToPurchase} data-id="element-124">
              <div className="mb-4 overflow-hidden rounded-xl shadow-lg" data-id="element-125">
                <img src="https://cdn.magicpatterns.com/uploads/1NM2LF7S3LVZBWx5cXQyr6/ChatGPT_Image_11_ene_2026,_17_36_21.png" alt="Bono ChatGPT" className="w-full h-auto transform group-hover:scale-105 transition duration-500" data-id="element-126" />
              </div>
              <div className="flex items-center gap-2 mb-2" data-id="element-127">
                <span className="bg-blue-500 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-128">
                  BONO 1
                </span>
                <span className="text-green-400 text-sm font-bold" data-id="element-129">GRATIS</span>
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-130">
                Inteligencia Artificial FÁCIL
              </h3>
              <p className="text-blue-100 text-sm" data-id="element-131">
                Aprendé a usar ChatGPT desde el celular para que te ayude a
                escribir mensajes, buscar recetas o resumir textos.
              </p>
            </div>

            {/* Bonus 2 */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/20 transition cursor-pointer group" onClick={scrollToPurchase} data-id="element-132">
              <div className="mb-4 overflow-hidden rounded-xl shadow-lg" data-id="element-133">
                <img src="https://cdn.magicpatterns.com/uploads/2ucM1GD4B79DLRsVEXL2vS/ChatGPT_Image_11_ene_2026,_17_37_01.png" alt="Bono MercadoLibre" className="w-full h-auto transform group-hover:scale-105 transition duration-500" data-id="element-134" />
              </div>
              <div className="flex items-center gap-2 mb-2" data-id="element-135">
                <span className="bg-blue-500 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-136">
                  BONO 2
                </span>
                <span className="text-green-400 text-sm font-bold" data-id="element-137">GRATIS</span>
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-138">
                MercadoLibre + Mercado Pago
              </h3>
              <p className="text-blue-100 text-sm" data-id="element-139">
                La guía definitiva para comprar, pagar servicios, transferir
                dinero y cobrar sin miedos ni errores.
              </p>
            </div>

            {/* Bonus 3 */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/20 transition cursor-pointer group" onClick={scrollToPurchase} data-id="element-140">
              <div className="mb-4 overflow-hidden rounded-xl shadow-lg" data-id="element-141">
                <img src="https://cdn.magicpatterns.com/uploads/dcS9kBUAbjmdLzArkwN6bz/ChatGPT_Image_11_ene_2026,_17_38_26.png" alt="Bono Anti-Estafas" className="w-full h-auto transform group-hover:scale-105 transition duration-500" data-id="element-142" />
              </div>
              <div className="flex items-center gap-2 mb-2" data-id="element-143">
                <span className="bg-blue-500 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-144">
                  BONO 3
                </span>
                <span className="text-green-400 text-sm font-bold" data-id="element-145">GRATIS</span>
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-146">Guía Anti-Estafas</h3>
              <p className="text-blue-100 text-sm" data-id="element-147">
                Protegé tu dinero y tu información. Aprendé a detectar mensajes
                falsos y llamadas sospechosas al instante.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 6. BENEFICIO DIRECTO - Life Change */}
      <section className="py-16 px-4 bg-slate-50" data-id="element-148">
        <div className="max-w-4xl mx-auto" data-id="element-149">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-slate-900 mb-12" data-id="element-150">
            ¿Qué cambia en tu vida con este manual?
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-151">
            <div className="bg-white p-8 rounded-2xl shadow-sm border-2 border-green-200" data-id="element-152">
              <div className="bg-green-100 w-14 h-14 rounded-full flex items-center justify-center mb-4" data-id="element-153">
                <span className="text-3xl" data-id="element-154">✅</span>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-3" data-id="element-155">
                Recuperás tu independencia
              </h3>
              <p className="text-slate-700 text-lg" data-id="element-156">
                Ya no tenés que pedirle a nadie que te ayude con el celular.
                Hacés las cosas vos mismo, cuando querés, sin molestar a nadie.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border-2 border-blue-200" data-id="element-157">
              <div className="bg-blue-100 w-14 h-14 rounded-full flex items-center justify-center mb-4" data-id="element-158">
                <span className="text-3xl" data-id="element-159">🛡️</span>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-3" data-id="element-160">
                Te sentís seguro y protegido
              </h3>
              <p className="text-slate-700 text-lg" data-id="element-161">
                Sabés exactamente qué hacer y qué NO hacer. Identificás estafas,
                protegés tu dinero, y usás el celular con tranquilidad.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border-2 border-purple-200" data-id="element-162">
              <div className="bg-purple-100 w-14 h-14 rounded-full flex items-center justify-center mb-4" data-id="element-163">
                <span className="text-3xl" data-id="element-164">💪</span>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-3" data-id="element-165">
                Ganás confianza en vos mismo
              </h3>
              <p className="text-slate-700 text-lg" data-id="element-166">
                Dejás de sentirte "torpe" o "viejo". Demostrás que podés
                aprender y adaptarte, como lo hiciste toda tu vida.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border-2 border-orange-200" data-id="element-167">
              <div className="bg-orange-100 w-14 h-14 rounded-full flex items-center justify-center mb-4" data-id="element-168">
                <span className="text-3xl" data-id="element-169">🌟</span>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-3" data-id="element-170">
                Aprovechás todo lo que ofrece
              </h3>
              <p className="text-slate-700 text-lg" data-id="element-171">
                Pagás servicios, comprás online, te comunicás mejor, usás apps
                útiles. El celular deja de ser un problema y se convierte en una
                herramienta.
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-r from-blue-600 to-blue-800 p-10 rounded-3xl text-white text-center" data-id="element-172">
            <p className="text-2xl md:text-3xl font-bold mb-4" data-id="element-173">
              En resumen: dejás de depender, dejás de tener miedo, y empezás a
              vivir más tranquilo.
            </p>
            <p className="text-xl text-blue-100" data-id="element-174">
              Eso es lo que vale este manual. No es solo información, es
              recuperar tu autonomía.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-16 px-4 bg-white" data-id="element-175">
        <div className="max-w-6xl mx-auto" data-id="element-176">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-slate-900 mb-12" data-id="element-177">
            Ellos ya perdieron el miedo
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-178">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-179">
              <div className="flex gap-1 text-yellow-400 mb-4" data-id="element-180">
                <Star className="w-5 h-5 fill-current" data-id="element-181" />
                <Star className="w-5 h-5 fill-current" data-id="element-182" />
                <Star className="w-5 h-5 fill-current" data-id="element-183" />
                <Star className="w-5 h-5 fill-current" data-id="element-184" />
                <Star className="w-5 h-5 fill-current" data-id="element-185" />
              </div>
              <p className="text-slate-700 mb-4 italic" data-id="element-186">
                "Por primera vez entiendo lo que hago con el celular. Sin apuro
                y sin miedo. Me siento mucho más tranquila."
              </p>
              <div className="flex items-center gap-3" data-id="element-187">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-bold" data-id="element-188">
                  M
                </div>
                <div data-id="element-189">
                  <p className="font-bold text-slate-900" data-id="element-190">María, 52 años</p>
                  <p className="text-xs text-slate-500" data-id="element-191">Buenos Aires</p>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-192">
              <div className="flex gap-1 text-yellow-400 mb-4" data-id="element-193">
                <Star className="w-5 h-5 fill-current" data-id="element-194" />
                <Star className="w-5 h-5 fill-current" data-id="element-195" />
                <Star className="w-5 h-5 fill-current" data-id="element-196" />
                <Star className="w-5 h-5 fill-current" data-id="element-197" />
                <Star className="w-5 h-5 fill-current" data-id="element-198" />
              </div>
              <p className="text-slate-700 mb-4 italic" data-id="element-199">
                "Dejé de pedir ayuda a mis nietos para todo. Eso ya vale la pena
                la inversión. Muy recomendado."
              </p>
              <div className="flex items-center gap-3" data-id="element-200">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center text-green-600 font-bold" data-id="element-201">
                  C
                </div>
                <div data-id="element-202">
                  <p className="font-bold text-slate-900" data-id="element-203">Carlos, 61 años</p>
                  <p className="text-xs text-slate-500" data-id="element-204">Rosario</p>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-205">
              <div className="flex gap-1 text-yellow-400 mb-4" data-id="element-206">
                <Star className="w-5 h-5 fill-current" data-id="element-207" />
                <Star className="w-5 h-5 fill-current" data-id="element-208" />
                <Star className="w-5 h-5 fill-current" data-id="element-209" />
                <Star className="w-5 h-5 fill-current" data-id="element-210" />
                <Star className="w-5 h-5 fill-current" data-id="element-211" />
              </div>
              <p className="text-slate-700 mb-4 italic" data-id="element-212">
                "Está explicado como me gusta. Claro y simple, sin vueltas
                raras. Las fotos ayudan muchísimo."
              </p>
              <div className="flex items-center gap-3" data-id="element-213">
                <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center text-purple-600 font-bold" data-id="element-214">
                  L
                </div>
                <div data-id="element-215">
                  <p className="font-bold text-slate-900" data-id="element-216">Laura, 47 años</p>
                  <p className="text-xs text-slate-500" data-id="element-217">Córdoba</p>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-218">
              <div className="flex gap-1 text-yellow-400 mb-4" data-id="element-219">
                <Star className="w-5 h-5 fill-current" data-id="element-220" />
                <Star className="w-5 h-5 fill-current" data-id="element-221" />
                <Star className="w-5 h-5 fill-current" data-id="element-222" />
                <Star className="w-5 h-5 fill-current" data-id="element-223" />
                <Star className="w-5 h-5 fill-current" data-id="element-224" />
              </div>
              <p className="text-slate-700 mb-4 italic" data-id="element-225">
                "Aprendí a pagar y transferir sin miedo. Antes iba al banco para
                todo, ahora lo hago desde el sillón."
              </p>
              <div className="flex items-center gap-3" data-id="element-226">
                <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center text-orange-600 font-bold" data-id="element-227">
                  J
                </div>
                <div data-id="element-228">
                  <p className="font-bold text-slate-900" data-id="element-229">Jorge, 65 años</p>
                  <p className="text-xs text-slate-500" data-id="element-230">Mendoza</p>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-100" data-id="element-231">
              <div className="flex gap-1 text-yellow-400 mb-4" data-id="element-232">
                <Star className="w-5 h-5 fill-current" data-id="element-233" />
                <Star className="w-5 h-5 fill-current" data-id="element-234" />
                <Star className="w-5 h-5 fill-current" data-id="element-235" />
                <Star className="w-5 h-5 fill-current" data-id="element-236" />
                <Star className="w-5 h-5 fill-current" data-id="element-237" />
              </div>
              <p className="text-slate-700 mb-4 italic" data-id="element-238">
                "No es un curso aburrido. Es un manual de verdad que tenés a
                mano cuando lo necesitás."
              </p>
              <div className="flex items-center gap-3" data-id="element-239">
                <div className="w-10 h-10 bg-pink-100 rounded-full flex items-center justify-center text-pink-600 font-bold" data-id="element-240">
                  A
                </div>
                <div data-id="element-241">
                  <p className="font-bold text-slate-900" data-id="element-242">Ana, 58 años</p>
                  <p className="text-xs text-slate-500" data-id="element-243">La Plata</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 7. CTA CLARO - Pricing Section */}
      <section id="compra" className="py-20 px-4 bg-white" data-id="element-244">
        <div className="max-w-3xl mx-auto" data-id="element-245">
          <div className="bg-white rounded-3xl shadow-2xl border-2 border-blue-100 overflow-hidden" data-id="element-246">
            <div className="bg-blue-600 p-4 text-center" data-id="element-247">
              <p className="text-white font-bold text-lg" data-id="element-248">
                OFERTA ESPECIAL POR TIEMPO LIMITADO
              </p>
            </div>

            <div className="p-8 md:p-12 text-center" data-id="element-249">
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-2" data-id="element-250">
                Manual "Celular Sin Ayuda"
              </h2>
              <p className="text-xl text-slate-600 mb-8" data-id="element-251">
                + Los 3 Bonos de Regalo (ChatGPT, MercadoPago, Anti-Estafas)
              </p>

              <div className="flex justify-center items-baseline gap-2 mb-8" data-id="element-252">
                <span className="text-2xl text-slate-400 line-through" data-id="element-253">
                  $35.000
                </span>
                <span className="text-6xl font-extrabold text-blue-600" data-id="element-254">
                  $19.990
                </span>
                <span className="text-xl text-slate-500" data-id="element-255">ARS</span>
              </div>

              <div className="space-y-4 mb-10 max-w-md mx-auto text-left" data-id="element-256">
                <div className="flex items-center gap-3" data-id="element-257">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-258" />
                  <span className="text-slate-700" data-id="element-259">
                    Acceso inmediato y de por vida
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-260">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-261" />
                  <span className="text-slate-700" data-id="element-262">
                    Lectura fácil en cualquier pantalla
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-263">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-264" />
                  <span className="text-slate-700" data-id="element-265">
                    Garantía de satisfacción
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-266">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-267" />
                  <span className="text-slate-700" data-id="element-268">
                    Soporte por email si tenés dudas
                  </span>
                </div>
              </div>

              <a href="https://checkout3.rosetadigital.com/cart/45857309196473:1" className="block w-full bg-green-600 hover:bg-green-700 text-white text-2xl font-bold py-5 px-8 rounded-xl shadow-lg transform transition hover:scale-105 mb-4" data-id="element-269">
                DESCARGAR Y ACCEDER HOY MISMO
              </a>

              <p className="text-sm text-slate-500 flex items-center justify-center gap-2" data-id="element-270">
                <Lock className="w-4 h-4" data-id="element-271" /> Pago 100% seguro y encriptado
              </p>
            </div>

            <div className="bg-slate-50 p-6 border-t border-slate-100 flex flex-wrap justify-center gap-6 grayscale opacity-70" data-id="element-272">
              <span className="font-bold text-slate-400" data-id="element-273">Visa</span>
              <span className="font-bold text-slate-400" data-id="element-274">Mastercard</span>
              <span className="font-bold text-slate-400" data-id="element-275">Mercado Pago</span>
              <span className="font-bold text-slate-400" data-id="element-276">Rapipago</span>
              <span className="font-bold text-slate-400" data-id="element-277">PagoFácil</span>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-20 px-4 bg-blue-900 text-center" data-id="element-278">
        <div className="max-w-4xl mx-auto" data-id="element-279">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-8" data-id="element-280">
            No dejes que el miedo te siga frenando
          </h2>
          <p className="text-xl text-blue-100 mb-10 max-w-2xl mx-auto" data-id="element-281">
            Hacé click ahora y empezá a usar tu celular con confianza. Descarga
            inmediata. Sin vueltas.
          </p>

          <button onClick={scrollToPurchase} className="w-full md:w-auto bg-green-500 hover:bg-green-600 text-white text-xl md:text-2xl font-bold py-5 px-10 rounded-xl shadow-lg transform transition hover:scale-105" data-id="element-282">
            👉 DESCARGAR AHORA
          </button>

          <p className="mt-6 text-blue-200 text-sm" data-id="element-283">
            Descarga inmediata · Android e iPhone · Pensado para mayores de 40
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 text-slate-400 py-12 px-4 text-center" data-id="element-284">
        <div className="max-w-6xl mx-auto" data-id="element-285">
          <p className="mb-4" data-id="element-286">
            © 2024 Manual Celular Sin Ayuda. Todos los derechos reservados.
          </p>
          <p className="text-sm text-slate-600" data-id="element-287">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}